import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import '../icon/lib-icon';
import css from './lib-action-bar.css';

@customElement('lib-action-bar-item')
export class LibActionBarItem extends LibElement {
  protected override get hostFocusSelector(): string { return this.closest('lib-action-bar') ? '' : 'button'; }
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  @property() text = '';
  @property({ attribute: 'icon-url' }) iconUrl = '';
  @property({ type: Boolean }) disabled = false;

  protected override updated() { this.emit('lib-action-item-change'); }

  override render() {
    if (this.closest('lib-action-bar')) return nothing;
    return html`<button type="button" class="lib-actionbar-item" aria-label=${this.text} aria-pressed="false"
      ?disabled=${this.disabled} @click=${(event: MouseEvent) => { if (this.disabled) event.stopPropagation(); }}>
      ${this.iconUrl ? html`<lib-icon icon-url=${this.iconUrl}></lib-icon>` : nothing}
    </button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-action-bar-item': LibActionBarItem; }
}
